export const SUCCESS_PROPERTY_FEATURE="SUCCESS_PROPERTY_FEATURE";
export const FAILED_PROPERTY_FEATURE="FAILED_PROPERTY_FEATURE";
export const REQUST_PROPERTY_FEATURE="REQUST_PROPERTY_FEATURE";
